/**
 * 取消收藏。
 *
 * @param resourceId - 资源的 ID。
 * @param resourceType - 资源的类型。
 * @param collectionId - 收藏夹的 ID。
 * @returns 返回取消收藏的 Promise。
 *
 * @remarks
 * 该函数发送请求以从指定资源中取消收藏。需要提供资源的 ID、类型以及收藏夹的 ID。
 * 请注意，如果发生请求失败，错误将不会在此处捕获，而是被传递给调用方处理。
 *
 * @example
 * ```typescript
 * await requestCancelFavByRes(123, 1, 456);
 * ```
 */
export async function requestCancelFavByRes(
  resourceId: number,
  resourceType: number,
  collectionId: number
) {
  return http.post('/v1/favorite/remove_favorite_by_resource', {
    resource_id: resourceId,
    list_id: collectionId,
    type: resourceType
  })
}
